import type { Craft } from "@/shared/work-orders-modals/models/Craft";
import { get } from "lodash-es";
import { useWorkOrdersContext } from "../context/workOrdersContext";
import type { StatusCode } from "../models/Filters";
import { getCrafts } from "@/pages/task-list/repositorie/TaskListRepositorie";

type Props = {
	setIsCraftLoading: (isLoading: boolean) => void;
	setCraftError: (err: string) => void;
};

export const useLoadfilters = ({ setIsCraftLoading, setCraftError }: Props) => {
	const { actions } = useWorkOrdersContext();

	const loadFilterCrafts = async () => {
		setIsCraftLoading(true);
		const res = await getCrafts();
		if (res.ok) {
			let craftSource = get(res, "data.tables[0].rows", []);
			if (craftSource) {
				craftSource.forEach((row: Craft) => {
					row.id = row.CraftId;
					row.description = row.CraftName;
					row.color = row.Color;
				});
				craftSource = craftSource.map(({ id, description, color }: Craft) => ({
					id,
					description,
					color,
				}));
				craftSource.push({ id: "A", description: "All crafts" });
				actions.setCraftsWorkOrders(craftSource);
			}
			setIsCraftLoading(false);
		} else {
			setCraftError(res.message);
			setIsCraftLoading(false);
		}

		const typeSource = [];
		typeSource.push({ id: "PM", description: "PM" });
		typeSource.push({ id: "RM", description: "RM" });
		typeSource.push({ id: "A", description: "All types" });
		actions.setTypesCodesWorkOrders(typeSource);
	};

	const loadFilterCloser = () => {
		const listStatusCode = [
			{ id: "C", description: "Closed" },
			{ id: "O", description: "Open" },
			{ id: "A", description: "All status" },
		];
		actions.setStatusCodesWorkOrders(listStatusCode as StatusCode[]);
		actions.setStatusCodeWorkOrders("O");
	};

	return { loadFilterCrafts, loadFilterCloser };
};
